<div class="skl-roles-privileges" aria-busy="true" aria-label="Loading role permissions">
  <div class="skl-card">
    <div class="skl-card__body">
      <app-skeleton width="220px" height="18px" borderRadius="4px" marginBottom="20px"></app-skeleton>

      <div class="skl-table-wrap">
        <div class="skl-row skl-row--header">
          @for (col of tableCols; track col) {
            <div class="skl-cell">
              <app-skeleton [width]="col === 1 ? '78%' : col === 4 ? '60%' : col === 6 ? '52%' : '70%'" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
            </div>
          }
        </div>

        @for (row of tableRows; track row) {
          <div class="skl-row skl-row--data">
            @for (col of tableCols; track col) {
              <div class="skl-cell">
                @if (col === 6) {
                  <app-skeleton width="72px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
                } @else {
                  <app-skeleton [width]="col === 1 ? '88%' : col === 2 ? '68%' : col === 3 ? '74%' : col === 4 ? '56%' : '62%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div class="skl-card skl-card--spaced">
    <div class="skl-card__body">
      <app-skeleton width="190px" height="18px" borderRadius="4px" marginBottom="20px"></app-skeleton>

      <div class="skl-form-row">
        @for (col of formCols; track col) {
          <div class="skl-form-col">
            <app-skeleton width="120px" height="13px" borderRadius="3px" marginBottom="10px"></app-skeleton>
            <app-skeleton [width]="col === 4 ? '100%' : '100%'" height="40px" borderRadius="4px" marginBottom="0"></app-skeleton>
          </div>
        }
      </div>
    </div>
  </div>
</div>